// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-89ddb1d0] .user-dialog .el-dialog__body {\n  padding: 0 !important;\n  height: 600px;\n}\n.btn-box[data-v-89ddb1d0] {\n  padding: 0 20px;\n}\n[data-v-89ddb1d0].el-alert--success.is-light {\n  background: #fff1e5 !important;\n  font-size: 12px;\n  color: #ff7d00 !important;\n}\n[data-v-89ddb1d0] .el-alert--success.is-light .el-alert__description {\n  color: #ff7d00 !important;\n}", ""]);
// Exports
module.exports = exports;
